import axios from '@/axios.js'
import { normalizeSiteSetting } from './siteState'

let phoneCodesPromise = null
let platformsAdultPromise = null
let platformsPromise = null

export async function loadHarmonyData(slug, userId = 0) {
  const response = await axios.get(`/site/${slug}`, {
    params: { user_id: userId }
  })
  const site = response.data?.site
  if (!site) {
    throw new Error('SITE_NOT_FOUND')
  }

  let rawSetting = null
  if (site.site_settings?.setting) {
    if (typeof site.site_settings.setting === 'string') {
      try {
        rawSetting = JSON.parse(site.site_settings.setting)
      } catch (e) {
        console.error('Error parsing site setting:', e)
        rawSetting = null
      }
    } else if (typeof site.site_settings.setting === 'object') {
      rawSetting = site.site_settings.setting
    }
  }

  const normalizedSetting = normalizeSiteSetting(rawSetting)

  return {
    harmony: site,
    visits: site.visits_count || 0,
    likes: site.likes_count || 0,
    isLiked: site.user_has_liked || false,
    isOwner: site.owner || false,
    isFollowed: site.user_has_followed || false,
    monetize: response.data?.monetize || false,
    settings: normalizedSetting,
    translatedText: response.data?.translatedText || '',
    translatedSelectText: response.data?.translatedSelectText || '',
    translatedDescription: response.data?.translatedDescription || '',
    translatedFooterText: response.data?.translatedFooterText || '',
  }
}

export async function getPhoneCodesCached() {
  if (!phoneCodesPromise) {
    phoneCodesPromise = axios.get('/get-phone-codes').then(response => {
      return response.data.map(code => {
        code.flag = `https://flagcdn.com/24x18/${code.code.toLowerCase()}.png`
        return code
      })
    }).catch(err => {
      phoneCodesPromise = null
      throw err
    })
  }
  return phoneCodesPromise
}

export async function getPlatformsAdultCached() {
  const cacheKey = 'harmony_platforms_adult_cache'
  const ttlKey = 'harmony_platforms_adult_cache_ttl'
  const now = Date.now()

  try {
    const cachedData = localStorage.getItem(cacheKey)
    const cachedTtl = localStorage.getItem(ttlKey)
    if (cachedData && cachedTtl && now < Number(cachedTtl)) {
      return JSON.parse(cachedData)
    }
  } catch (e) {
    // Ignore localStorage read errors
  }

  if (!platformsAdultPromise) {
    platformsAdultPromise = axios.get('get-platforms-adult').then(response => {
      try {
        localStorage.setItem(cacheKey, JSON.stringify(response.data))
        localStorage.setItem(ttlKey, String(now + 24 * 60 * 60 * 1000)) // 24 hours TTL
      } catch (e) {
        // Ignore localStorage write errors
      }
      return response.data
    }).catch(err => {
      platformsAdultPromise = null
      throw err
    })
  }
  return platformsAdultPromise
}

export async function getPlatformsCached() {
  if (!platformsPromise) {
    platformsPromise = axios.get('get-platforms').then(response => {
      return response.data
    }).catch(err => {
      platformsPromise = null
      throw err
    })
  }
  return platformsPromise
}
